// GLOBAL VARIABLE SETUP
// =================================================================================================
// COMPONENTS
import React from 'react';

import '../../styles/modal.css'

// HELP FUNCTIONS
import '../../utils/kawo-tooltip';

import _ from 'underscore';
import feather from 'feather-icons';


// MAIN REACT CLASS DECLARATION
// =================================================================================================
class Modal extends React.Component {


	// REACT APP CONSTRUCTOR
	// =============================================================================================
	constructor( props ) {

		super( props );

		this.state = {
			detect: false
		};

		window.trackEvent( 'Pageview', {
			action: 'save-modal'
		});
	}


	// MAIN RENDER METHOD
	// =============================================================================================
	render() {

		let EditorScene = this.props.Editor,
			EditorState = EditorScene.state,
			modalContent;


		// SELECTION OF BUTTONS FOR OPTIONS WITH SRV/VIDEO ETC
		// -----------------------------------------------------------------------------------------
		let optionsComponent = <div className="options__container">
			<div className="btn-group">

				<div className="btn_text">
					<h3>Options</h3>
				</div>

				<button className="btn btn_close btn_trans btn_icon" onClick={ ( e ) => this.closeModal() }>
					<i className="icon" dangerouslySetInnerHTML={ { __html: feather.icons[ 'x' ].toSvg({ width: 22, height: 22 }) } } />
				</button>
			</div>

			<div className="btn_list">
				<button className={ EditorState.jsonSrt ? "btn" : "btn btn_disabled" } onClick={ ( e ) => this.mergeSrt( e ) }>Merge Subtitle With Video</button>

				<button className={ EditorState.jsonSrt ? "btn" : "btn btn_disabled" }
						onClick={ ( e ) => EditorScene.downloadSrt( e ) }>
					Download Srt File
				</button>
			</div>
		</div>;

		if ( EditorState.detect ) optionsComponent = <div className="options__container">

			<div className="btn-group">
				<div className="btn_text">
					<h3>What language is primarily spoken in the video? We'll try and detect sentences to get you started!</h3>
				</div>

				<button onClick={ ( e ) => this.closeModal() } className="btn btn_close btn_trans btn_icon">
					<i className="icon" dangerouslySetInnerHTML={ { __html: feather.icons[ 'x' ].toSvg({ width: 22, height: 22 }) } } />
				</button>
			</div>

			<div className="btn_list" onClick={( e ) => this.selectLanguage( e )}>
				<button className="btn" data-lang="en">English</button>
				<button className="btn" data-lang="zh-CN">Chinese</button>
				<button className="btn" data-lang="fr">French</button>
				<button className="btn" data-lang="de">German</button>
				<button className="btn" data-lang="es">Spanish</button>
				<button className="btn" data-lang="ja">Japanese</button>
			</div>
		</div>;


		// PROGRESS ELEMENT WHILE VIDEO IS BEING UPLOADED
		// -----------------------------------------------------------------------------------------
		let progessComponent = <div className="progress__bar">

			{ EditorState.processing
				? <h3>Processing your video</h3>
				: <h3>Uploading your video</h3>
			}

			<div className="wavelengths" style={{ width: ( EditorState.processing ? 100 : EditorState.progress  || 0 ) + '%'}}>
				<div className="wavelength"/>
				<div className="wavelength"/>
			</div>

			{ EditorState.processing
				? <h3>You might want to grab a coffee, this can take a few minutes</h3>
				: <h3>{( this.props.Editor.state.progress || 0 ) + '%'}</h3>
			}
		</div>;

		let errorComponent = <div className="error__component">
			<dic className="btn-group">
				<div className="btn_text">
					<h3>Oops</h3>
				</div>

				<button onClick={ ( e ) => this.closeModal() } className="btn btn_close btn_trans btn_icon">
					<i className="icon" dangerouslySetInnerHTML={ { __html: feather.icons[ 'x' ].toSvg({ width: 22, height: 22 }) } } />
				</button>
			</dic>
			<h3>Something went wrong while processing your video.</h3>
			<h3>{ "Error: " + EditorState.xhrError }</h3>
		</div>;


		// FIGURE OUT WHAT CONTENT IS DISPLAYED IN THE MODAL
		// -----------------------------------------------------------------------------------------
		if ( EditorState.xhrError ) modalContent = errorComponent;

		else if ( EditorState.progress || EditorState.processing ) modalContent = progessComponent;

		else modalContent = optionsComponent;

		return <div className="modal__shade">
			<div className="modal__shade__container__gradient" style={ EditorState.progress || EditorState.processing ? { minHeight: '400px' } : {} }>
				{modalContent}
			</div>
		</div>
	}


	// =============================================================================================
	componentDidUpdate() {
		let waves = document.querySelectorAll( '.wavelength' ),
			container = document.querySelector( '.progress__bar' ),
			updateWaves = !( waves && waves.length && waves[0].childNodes.length ),
			padding = 40,
			animation = [],
			count,
			wave;


		// CHECK IF THE PROGRESS WAVEFORM IS IN THE DOM AND START ANIMATING IT
		// -----------------------------------------------------------------------------------------
		if ( this.props.Editor.state.progress && !( waves && waves[0].childNodes.length ) && updateWaves ) {

			for ( let i = 0; i < waves.length; i++ ) {

				wave = waves[ i ];

				wave.style.width = ( container.offsetWidth - padding ) + 'px';

				count = ( container.offsetWidth - padding ) / 4;

				for ( let x = 0; x < count; x++ ) {

					let div = document.createElement( 'div' );

					if ( !animation[ x ] ) animation[ x ] = Math.floor( Math.random() * 700 ) + 600 + 'ms';

					div.style.animationDuration = animation[ x ];

					wave.appendChild( div );

				}
			}

			this.setState( prevState => ({ generateWaves: false }))
		}
	}


	// =============================================================================================
	closeModal() {
		this.props.Editor.setState( prevState => ({
			detect: false,
			openModal: false,
			xhrError: false
		}) );
	}


	// =============================================================================================
	mergeSrt() {

		if ( this.props.Editor.state.jsonSrt ) this.props.Editor.uploadVideo( 'merge' )
	}


	// =============================================================================================
	selectLanguage( e ) {
		let lang = e.currentTarget.dataset.lang;

		// UPLOAD VIDEO WITH LANG SET
		this.props.Editor.uploadVideo( 'detect', lang );
	}
}

export default Modal;


// WEBPACK FOOTER //
// ./src/scenes/Editor/modal.js